import { getPlantMis, upsertPlantMis } from "../../../../../api/misApi";
import { setLedgerInMis } from "./ledger";
import { setSwitchPolicyInMis } from "./switchLink";

// The MIS JSON inside a record, where MISContext and InvoicesTab read it
// (`record.data.data`). A missing record, or one with nothing stored yet, is a
// valid empty start. Anything else means the record isn't shaped the way the
// MIS module writes it - and since upsert REPLACES the stored data, saving
// against a guess could wipe invoices, so this refuses instead.
const storedRoot = (record) => {
  if (record == null) return {};

  const root = record?.data?.data;
  if (root && typeof root === "object") return root;

  const stored = record?.data;
  const nothingStored =
    stored == null ||
    (typeof stored === "object" &&
      Object.keys(stored).every((key) => key === "data" && stored[key] == null));
  if (nothingStored) return {};

  throw new Error("Unrecognised MIS record shape - not overwriting it");
};

/**
 * Saves one project revision's cost entries into the plant's MIS record, the
 * way the MIS module saves its own data (MISContext.saveDeviationsToApi):
 * read the record, merge the change in, write the whole thing back, so
 * everything already in it (invoices, deviations, other projects' entries)
 * travels with the write.
 *
 * getPlantMis turns "no MIS record yet" (404) into null, which is a valid
 * starting point. Any other read failure throws, so a failed read can never
 * end up overwriting the record with a near-empty one.
 */
export const saveLedger = async ({ plantId, projectId, revision, entries }) => {
  const current = await getPlantMis(plantId);
  const next = setLedgerInMis(storedRoot(current), projectId, revision, entries);
  await upsertPlantMis(plantId, next);
  return next;
};

/** Same read-merge-write, for the switch model's client/vendor lag policy. */
export const saveSwitchPolicy = async ({ plantId, projectId, revision, policy }) => {
  const current = await getPlantMis(plantId);
  const next = setSwitchPolicyInMis(storedRoot(current), projectId, revision, policy);
  await upsertPlantMis(plantId, next);
  return next;
};
